import CallHistoryService from '../js/callHistoryService';
import LoggingService from 's2s-logging-service';

const callHistory = (state, action)=>{

  if (typeof state === 'undefined') {
    return CallHistoryService.getInstance().getHistory();
  }

  switch (action.type) {
    case "FAILED_CALL":
      LoggingService.getInstance().debug(' CALLHISTORY REDUCER --- FAILED_CALL');
      //console.log('******* CallHistory ... FAILED:', action.payload);
      CallHistoryService.getInstance().add({
        callId: action.payload.callid,
        timestamp: Date.now(),
        callerId: action.payload.params.calleridnumber,
        name: action.payload.params.calleridname,
        direction: action.payload.params.name ? action.payload.params.name : 'inbound',
        status: 'failed'
      });

      return CallHistoryService.getInstance().getHistory();

    case "CALLING":
      LoggingService.getInstance().debug(' CALLHISTORY REDUCER --- CALLING');
      //console.log('******* CallHistory ... calling:', action.payload)
      CallHistoryService.getInstance().add({
        callId: action.payload.callId,
        timestamp: Date.now(),
        callerId: action.payload.destination,
        name: '',
        direction: 'outbound',
        status: ''
      });
      return CallHistoryService.getInstance().getHistory();

    case "INCOMING_CALL":
      LoggingService.getInstance().debug('CALLHISTORY REDUCER --- INCOMING_CALL')
      //console.log('<<<<<<< CallHistory ... INCOMING CALL:', action.payload);
      CallHistoryService.getInstance().add({
        callId: action.payload.callid,  // NOTE the callid is purposely all lower case for incoming call... NOT A TYPO!!!
        timestamp: Date.now(),
        callerId: action.payload.params.calleridnumber,
        name: action.payload.params.calleridname,
        direction: action.payload.params.name ? action.payload.params.name : 'inbound',
        status: ''
      });

      return CallHistoryService.getInstance().getHistory();

    case 'CLEARING_HISTORY':
      LoggingService.getInstance().debug('CALLHISTORY REDUCER --- CLEARING_HISTORY')
      CallHistoryService.getInstance().clearHistory();
      return [];

    default:
     return state;
    }
};

export { callHistory };



// WEBPACK FOOTER //
// ./src/reducers/callHistory-reducer.js